import {
  Box,
  ModalProvider,
  PaginationProvider,
  SearchProvider,
  SortProvider,
  PageViewProvider,
  UpgradeSubscriptionModalType,
  FilterProvider,
  DropdownOptions,
  TooltipPopup,
} from "dash-ui";

import MovePropertyToFolderModal from "containers/portfolio/MovePropertyToFolderModal/MovePropertyToFolderModal";
import RemovePropertyFromPortfolio from "containers/portfolio/RemovePropertyFromPortfolio/RemovePropertyFromPortfolio";
import RemoveFolderFromPortfolio from "containers/portfolio/RemoveFolderFromPortfolio/RemoveFolderFromPortfolio";
import SharePortfolioModal from "containers/portfolio/SharePortfolioModal/SharePortfolioModal";
import UpgradeSubscriptionModal from "common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal";

import AddPortfolioFolder from "./components/AddPortfolioFolder/AddPortfolioFolder";
import PortfoliosPageTopBar from "./components/PortfoliosPageTopBar/PortfoliosPageTopBar";
import PortfoliosPageView from "./components/PortfoliosPageView/PortfoliosPageView";
import { SubscriptionChangeConfirmationModal } from "pages/ProfilePage/components/ProfileBilling/components";
import { useGetPortfolioFolderRootQuery } from "gql/generated.graphql";
import ManageMediaKitModal from "containers/portfolio/ManageMediaKitModal/ManageMediaKitModal";

const PortfoliosPage = () => {
  const { data } = useGetPortfolioFolderRootQuery();

  const portfolio = data?.getPortfolioFolderRoot;
  return (
    <PaginationProvider perPage={9}>
      <SortProvider>
        <FilterProvider>
          <SearchProvider>
            <ModalProvider>
              <PageViewProvider>
                <Box w="100%">
                  <DropdownOptions />
                  <TooltipPopup />
                  <PortfoliosPageTopBar />
                  <PortfoliosPageView />
                  <AddPortfolioFolder />
                  <RemovePropertyFromPortfolio />
                  <RemoveFolderFromPortfolio />
                  <MovePropertyToFolderModal />
                  <SharePortfolioModal />
                  <ManageMediaKitModal />
                  <SubscriptionChangeConfirmationModal />
                  <UpgradeSubscriptionModal
                    type={UpgradeSubscriptionModalType.PORTFOLIO}
                  />
                </Box>
              </PageViewProvider>
            </ModalProvider>
          </SearchProvider>
        </FilterProvider>
      </SortProvider>
    </PaginationProvider>
  );
};

export default PortfoliosPage;
